"use strict";
const inaxSignalR_1 = require("./signalR/inaxSignalR");
const IInaxConfigService_interface_1 = require("./interfaces/IInaxConfigService.interface");
const inaxConfiguration_1 = require("./inaxConfiguration");
const IExpandablePanelCollection_interface_1 = require("../../commonUi/src/expandablePanel/interfaces/IExpandablePanelCollection.interface");
const expandablePanelCollection_service_1 = require("./expandablePanelCollectionService/expandablePanelCollection.service");
exports.SIGNALR_PROVIDER_ENTRY = { provide: inaxSignalR_1.SignalrWindow, useValue: window };
exports.INAX_CONFIG_PROVIDER_ENTRY = { provide: IInaxConfigService_interface_1.IINAXCONFIGSERVICE_TOKEN, useClass: inaxConfiguration_1.InaxConfiguration, multi: false };
exports.EXPANDABLE_PANEL_COLLECTION_ENTRY = { provide: IExpandablePanelCollection_interface_1.IEXPANDABLEPANELCOLLECTIONSERVICE_TOKEN, useClass: expandablePanelCollection_service_1.ExpandablePanelCollectionService, multi: false };
exports.INAX_COMMON_PROVIDER_ENTRIES = {
    SIGNALR_PROVIDER_ENTRY: exports.SIGNALR_PROVIDER_ENTRY,
    INAX_CONFIG_PROVIDER_ENTRY: exports.INAX_CONFIG_PROVIDER_ENTRY,
    EXPANDABLE_PANEL_COLLECTION_ENTRY: exports.EXPANDABLE_PANEL_COLLECTION_ENTRY
};
